const publishRequests = {
    list: {
        search: ' Search for branch name or location',
        providerFilterPlaceHolder: 'Service provider' ,
        noData:'There is no publish requests yet',
        home: "At customer's place"
    },
    card: {
        acceptLabel: 'Accept',
        rejectLabel:'Reject'
    },
    rejectModal: {
        title:'Reject publish request ',
        contentText:'Rejection reason',
        placeholder:'Enter rejection reason'
    },
    viewPublishRequest:{
        publishRequests : 'Publish requests',
        rejectionFlag:'Publish request is rejected',
        seeMore:'See more'
    }
}

export default publishRequests